import { render, staticRenderFns } from "./editBorrowView.vue?vue&type=template&id=756e7d52&scoped=true"
import script from "./editBorrowView.vue?vue&type=script&lang=js"
export * from "./editBorrowView.vue?vue&type=script&lang=js"
import style0 from "./editBorrowView.vue?vue&type=style&index=0&id=756e7d52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756e7d52",
  null
  
)

export default component.exports